export default __webpack_public_path__ + "static/media/regulatory--no-studded-snow-chains--g1.788d151e.png";